import React, { useEffect } from "react";
import styled from "styled-components";
import InlineSvg from "react-inlinesvg";
import { DownOutlined } from "@ant-design/icons";
import { Button, Dropdown, Grid, MenuProps } from "antd";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import { colors } from "@constants/colors";
import countryLangStore, {
  defaultUser,
  defaultCountry,
} from "@zustand/countryLang";
import Language from "./Language";
import { icons } from "@constants/icons";
import { MasterMedia } from "@constants/media";
import LogoOnClick from "./LogoOnClick";

const { useBreakpoint } = Grid;

type Props = {
  children?: JSX.Element[] | JSX.Element | React.ReactNode;
};

const LayoutAuth = ({ children }: Props) => {
  const navigator = useNavigate();
  const { country, user, setUser, setCountry, setLang } = countryLangStore();
  const screens = useBreakpoint();
  const { t } = useTranslation();

  useEffect(() => {
    country.country === "" && navigator("/menu-home");
  }, [country]);

  const checkUserIsResetPassword = async () => {
    const isFirstLogin = user.is_first_login;
    if (isFirstLogin === "true") {
      navigator("/reset-password");
    }
  };

  useEffect(() => {
    if (!user.access_token) {
      handleLogout();
    }
    checkUserIsResetPassword();
  }, [user]);

  const handleLogout = () => {
    setUser(defaultUser);
    setCountry(defaultCountry);
    navigator("/");
    setLang(process.env.REACT_APP_COUNTRY_LANG ?? "en");
  };

  const items: MenuProps["items"] = [
    {
      key: "0",
      label: t("Home:Logout"),
      onClick: handleLogout,
    },
  ];

  return (
    <Contents screens={!!screens.xs}>
      <div className="header">
        <LogoOnClick />
        <div className="header__btn">
          <Language />
          <Dropdown trigger={["click"]} menu={{ items, onClick: () => {} }}>
            <Button onClick={(e) => e.preventDefault()} className="btn-setting">
              {!screens.xs && <InlineSvg src={icons.iconUser} />}
              <span className="btn-name">{user.name}</span>
              <DownOutlined />
            </Button>
          </Dropdown>
        </div>
      </div>
      <div className="body">{children}</div>
      <div className="footer_layout">{process.env.REACT_APP_VERSION}</div>
    </Contents>
  );
};

export default LayoutAuth;

interface IStyle {
  screens: boolean;
}
const Contents = styled.div<IStyle>`
  background-color: ${colors.background};
  text-align: center;
  min-height: 100vh;
  .body {
    padding: 100px 0 50px;
  }
  .footer_layout {
    position: fixed;
    bottom: 0;
    left: 0;
  }
  .header {
    background-color: #fff;
    box-shadow: 0px 1px 18px rgba(181, 201, 235, 0.21),
      0px 3px 5px rgba(132, 147, 198, 0.12);
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px;
    margin: 0 0 50px;
    position: fixed;
    top: 0;
    width: 100%;
    z-index: 999;
    &__btn {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
    }
  }
  .logo {
    width: 100%;
    &__qovis {
      align-self: center;
      height: 45px;
      @media only screen and (max-width: ${MasterMedia.md}) {
        height: 35px;
      }
    }
  }
  .btn-setting {
    width: ${(val) => (val.screens ? "100px" : "170px")};
    border: 0px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    box-shadow: 0 0px 0 rgba(0, 0, 0, 0);
  }
  .btn-name {
    max-width: 90px;
    text-overflow: ellipsis;
    overflow: hidden;
  }
`;
